import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

import { styles } from './styles';
import { PrimaryButton, SecondaryButton } from 'components/common/buttons';

import { useConfirmation } from 'context/confirmation';
import { Divider } from '@material-ui/core';

export default function ConfirmationDialog() {
  const classes = styles();
  const {
    state: {
      isOpen,
      title = '',
      message = '',
      onConfirmation,
      primaryActionLabel,
    },
    dispatchConfirmation,
  } = useConfirmation();

  const handleConfirmClick = () => {
    handleClose();
    onConfirmation();
  };

  const handleClose = () => {
    dispatchConfirmation({ show: false });
  };

  return (
    <>
      {isOpen && (
        <Dialog open={isOpen} onClose={handleClose}>
          <DialogTitle disableTypography>{title}</DialogTitle>
          <Divider />
          <DialogContent className={classes.dialogContent}>{message}</DialogContent>
          <DialogActions>
            <SecondaryButton onClick={handleClose}>Cancel</SecondaryButton>
            <PrimaryButton onClick={handleConfirmClick}>
              {primaryActionLabel}
            </PrimaryButton>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
